import { render } from "./AdminAmbassadors.vue?vue&type=template&id=4b2f4ec6&scoped=true"
import script from "./AdminAmbassadors.vue?vue&type=script&lang=js"
export * from "./AdminAmbassadors.vue?vue&type=script&lang=js"

import "./AdminAmbassadors.vue?vue&type=style&index=0&id=4b2f4ec6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f4ec6"]])

export default __exports__